import React, {Suspense} from 'react';
import './App.css';
import {useSessionContext} from "./util/SessionContext";
import {createDefaultTheme} from "./theme";
import {StyledEngineProvider, ThemeProvider} from '@mui/material';
import {AppContextProvider} from "./util/AppContext";
import {useSsoLogin} from "./util/useSsoLogin";
import Layout from "./components/Layout";
import InactiveLogout from "./components/Logout/InactiveLogout";
import SelectPersonaDialog from "./components/Login2/SelectPersonaDialog";
import SsoHandoffFailed from "./components/Login2/SsoHandoffFailed";
import SelectSsoAccountDialog from "./components/Login2/SelectSsoAccountDialog";
import {OwnerHierarchyHost} from "./components/Common/StewardshipCell";

function App() {
    const sessionContext = useSessionContext();
    const {processing: ssoProcessing, selectingPersona, onPersonaSelected, failed: ssoFailed, fault: ssoFault, faultCode: ssoFaultCode,
           chooserAccounts, chooserSubmitting, onAccountChosen,
           preferredAccountUsid, onSignIn} = useSsoLogin(sessionContext);

    // Pick lists seeded since this session started would otherwise stay invisible until a full
    // logout -- a token refresh does not rewrite them.
    // NO PICK VALUES. They are the Data Catalog's picklists, fetched from t5/v1/pick_values, and
    // this app has no picklists to fill. Since login moved to t10 the token is t10.user.access,
    // which t5's authorizer has no branch for -- so the call 401'd on every page load.

    const theme = createDefaultTheme();
/*
    useEffect(() => {
        if (!sessionContext.valid()) {
            if (sessionContext.size() > 0) {
                console.log(`session is not valid but has content... resetting. ${JSON.stringify(sessionContext.dump())}`);
                sessionContext.reset();
            }
        }
    }, [sessionContext]);
*/
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <Suspense fallback={<div>Loading...</div>}>
                    <AppContextProvider value={{sessionContext}}>
                        {ssoProcessing ? (
                            <div style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100vh"}}>Signing you in…</div>
                        ) : ssoFailed ? (
                            <SsoHandoffFailed onSignIn={onSignIn} fault={ssoFault} code={ssoFaultCode}/>
                        ) : chooserAccounts ? (
                            <SelectSsoAccountDialog accounts={chooserAccounts} submitting={chooserSubmitting}
                                                    preferredAccountUsid={preferredAccountUsid} onChoose={onAccountChosen}/>
                        ) : selectingPersona ? (
                            <SelectPersonaDialog onSelected={onPersonaSelected}/>
                        ) : (
                            <>
                                <Layout/>
                                <InactiveLogout/>
                                {/* MOUNTED ONCE, FOR THE WHOLE APP. A Stewardship cell renderer runs
                                    per ROW, so it cannot own the drawer it opens -- a grid of a
                                    hundred rows would mount a hundred drawers to use one. The cells
                                    emit on EventBus.ownerHierarchy and this listens. It costs
                                    nothing closed: the chart is only built while open. */}
                                <OwnerHierarchyHost/>
                            </>
                        )}
                    </AppContextProvider>
                </Suspense>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

export default App;
